import { type ContentComponent, type DyRecsContent } from '../../../../../types/construct.types';

export const DyRecsHandler: ContentComponent<DyRecsContent> = ({
	content: {
		fields: { text }
	}
}) => {
	return <div id={text} data-testid="dy-recs-container"></div>;
};
